import { take } from "lodash-es";

import { AutocompleteAddress } from "@/services/bpost.service";

import { getDisplayValue } from "./displayValue.helpers";

type GetBoxSelectProps = {
    inputValue: string;
    address: AutocompleteAddress | null;
};

export const getBoxSelectProps = ({
    inputValue,
    address
}: GetBoxSelectProps) => {
    const match = inputValue.match(
        /(?<prefix>.*(?<boxType>bus|bte) )(?<box>.*)(?<suffix> -.*)/i
    );
    const addressPrefix = match?.groups?.prefix;
    const addressSuffix = match?.groups?.suffix;
    const box = match?.groups?.box?.toLowerCase();
    const boxType = match?.groups?.boxType;

    const boxSelectRegex = new RegExp(
        `^(${addressPrefix}).*(${addressSuffix})$`
    );

    // False if input differs from the box input query
    const isBoxSelect = boxSelectRegex.test(getDisplayValue(address));

    return {
        isBoxSelect: isBoxSelect,
        box: box,
        boxType: boxType
    };
};

type GetBoxAddressesProps = {
    address: AutocompleteAddress;
    boxType?: string;
    box?: string;
};

export const getBoxAddresses = ({
    address,
    boxType,
    box
}: GetBoxAddressesProps) => {
    const listOfBoxes = address.listOfBoxes ?? [];
    const boxes = box
        ? listOfBoxes.filter((b) => b.toLowerCase().includes(box))
        : listOfBoxes;

    return take(boxes, 5).map((box) => ({
        ...address,
        isComplete: true,
        boxNumber: box,
        string: `${address.streetName} ${address.houseNumber} ${boxType} ${box} - ${address.postalCode} ${address.municipalityName}`
    }));
};
